import React, { useState } from "react";
import { Plus } from "phosphor-react";

function CommentBox(props) {
  const [createComment, setCreateComment] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const toggleCreateComment = () => {
    setCreateComment(!createComment);
  };

  const { onSubmitNewComment } = props;

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleSubmittingNewComment = () => {
    onSubmitNewComment(inputValue);
    setCreateComment(!createComment);
  };

  if (createComment) {
    return (
      <div className="row">
        <div className="col-1">
          <button className="float-right" onClick={handleSubmittingNewComment}>
            post
          </button>
        </div>
        <div className="col-11">
          <textarea
            className="form-control"
            value={inputValue}
            onChange={handleInputChange}
          ></textarea>
        </div>
      </div>
    );
  } else {
    return (
      <div className="row mb-4">
        <div className="col-1">
          <button onClick={toggleCreateComment}>
            <Plus />
          </button>
        </div>
        <div className="col-11"></div>
      </div>
    );
  }
}

export default CommentBox;
